import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AuthPopup from "./AuthPopup";

/**
 * Login page - shows auth form for site users (wishlist, cart, account).
 * Dashboard has its own login at /dashboard/login.
 */
export default function Login() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname || "/";

  if (loading) {
    return (
      <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (user) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="login-page" style={{ minHeight: "70vh", padding: "80px 20px", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--site-bg, #F1E3E5)" }}>
      <AuthPopup
        onClose={() => navigate("/")}
        onSuccess={() => navigate(from, { replace: true })}
      />
    </div>
  );
}
